import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateEmail,
  signOut as firebaseSignOut,
} from "firebase/auth";
import {
  doc,
  setDoc,
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";
import { auth, db } from "../firebase/config";

export const login = async (email, password) => {
  try {
    if (email === "admin" && password === "admin") {
      return {
        user: { email: "admin", uid: "admin" },
        userType: "admin",
      };
    }
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    console.log("Fetching user doc for UID:", userCredential.user.uid);
    const userDoc = await getDoc(
      doc(db, "users_driverequipment", userCredential.user.uid)
    );
    if (!userDoc.exists()) {
      throw new Error("User data not found");
    }
    const userData = userDoc.data();
    const userType =
      userData.userType || determineUserType(userData.roles || {});
    return {
      user: userCredential.user,
      userType,
    };
  } catch (error) {
    console.error("Login error:", error);
    throw new Error("Failed to login: " + error.message);
  }
};

export const createUser = async (email, password, roles) => {
  try {
    const response = await fetch(
      "https://us-central1-study-abroad-admin.cloudfunctions.net/api/create-user",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password, roles }),
      }
    );
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || "Failed to create user");
    }
    return data;
  } catch (error) {
    console.error("Create user error:", error);
    throw new Error(error.message);
  }
};

export const updateUser = async (id, email, roles) => {
  try {
    const userRef = doc(db, "users_driverequipment", id);
    const userType = determineUserType(roles);
    await updateDoc(userRef, {
      email,
      userType,
      roles: {
        isAdmin: roles.isAdmin || false,
        isDriver: roles.isDriver || false,
        isEquipmentMan: roles.isEquipmentMan || false,
      },
    });
    const user = auth.currentUser;
    if (user && user.uid === id && user.email !== email) {
      await updateEmail(user, email);
    }
  } catch (error) {
    throw new Error("Failed to update user: " + error.message);
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await fetch(
      `https://us-central1-study-abroad-admin.cloudfunctions.net/api/delete-user/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.error || "Failed to delete user");
    }
    return data;
  } catch (error) {
    console.error("Delete user error:", error);
    throw new Error(error.message);
  }
};

export const getUsers = async () => {
  try {
    const querySnapshot = await getDocs(
      collection(db, "users_driverequipment")
    );
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    throw new Error("Failed to fetch users: " + error.message);
  }
};

export { firebaseSignOut };

const determineUserType = (roles) => {
  if (roles.isAdmin) return "admin";
  if (roles.isDriver && roles.isEquipmentMan) return "both";
  if (roles.isDriver) return "driver";
  if (roles.isEquipmentMan) return "equipmentMan";
  return "driver";
};
